"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const reactstrap_1 = require("reactstrap");
const components_1 = require("./../../components");
const Datagrid_1 = require("./Datagrid");
require("./../styles/ListPageExample");
const styles = {
    pageComp: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingLeft: 10,
        '-webkit-box-orient': 'vertical',
        '-webkit-box-direction': 'normal',
    },
    pageCompBody: {
        position: 'fixed',
        top: 54,
        left: 10,
        height: 'calc(100vh - 54px)',
        width: 'calc(100% - 10px)',
        overflow: 'hidden',
    },
};
const drawerContent = (React.createElement("div", null,
    React.createElement(reactstrap_1.Nav, { vertical: true },
        React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer active", href: "#" }, "Link 1"),
        React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer", href: "#" }, "Link 2")),
    React.createElement("hr", null),
    React.createElement("h3", { className: "section-title" }, "Section"),
    React.createElement(reactstrap_1.Nav, { vertical: true },
        React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer", target: "_blank", href: "https://www.beakyn.com/", rel: "noopener" }, "Beakyn"),
        React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer", target: "_blank", href: "https://www.google.com", rel: "noopener" }, "Google")),
    React.createElement("div", { className: "brands" },
        React.createElement("img", { src: "https://storage.googleapis.com/outfront/assets/images/beakyn-brand.png", width: "32", height: "auto", alt: "Beakyn Company" }))));
exports.ListPageExample = () => (React.createElement(components_1.Layout, { breadcrumbs: [React.createElement("a", { href: "#" }, "Link to List Page"), 'Other Path'], drawerContent: drawerContent, drawerHeaderTitle: "App Name", mainNavTitle: "Some Page", onDrawerClose: () => console.log('close'), onDrawerOpen: () => console.log('open') },
    React.createElement("div", { className: "page-comp" },
        React.createElement("div", { className: "page-comp-body page-comp-body-fullscreen" },
            React.createElement(Datagrid_1.ComplexDatagrid, null)))));
exports.ListPageExample.displayName = 'ListPageExample';



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/ListPageExample.tsx
// module id = 470
// module chunks = 0